import React from 'react'
import { useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Dropdown from './dropdown';
import FilterFunctions from '../../../functions/public/filter';
import Sort from './sort';
import { ReactComponent as CrossIcon} from '../../../images/icons/cross.svg'

const Bar = ({baseUrl,searchParams}) => {
    const navigate = useNavigate();
    const [allcategoryList,setAllCategoryList] = useState([]);
    const [categoryList,setCategoryList] = useState([]);
    const [subcategoryList,setSubCategoryList] = useState([]);
    const [brandList,setBrandList] = useState([]);
    const [conditionList,setConditionList] = useState([]);
    const [colorList,setColorList] = useState([]);
    const [activeDrop,setActiveDrop] = useState(0);


    useEffect(()=>{
        FilterFunctions.Category(setAllCategoryList)
        FilterFunctions.Brand(setBrandList)
        FilterFunctions.Condition(setConditionList)
        FilterFunctions.Color(setColorList)
    },[])

    useEffect(()=>{
        var collectionListSend = [];
        for (let index = 0; index < allcategoryList.length; index++) {
          const element = allcategoryList[index];
          if(element.parentid === 0){
            collectionListSend.push({
              name: element.title,
              id: String(element.id)
            })
          }
        }
        setCategoryList(collectionListSend);
        var scolname = searchParams.get('category') || "0";
        if(scolname != "0"){
            var scol = 0;
            for (let index = 0; index < allcategoryList.length; index++) {
                const element = allcategoryList[index];
                if(element.parentid === 0){
                    if(element.title === scolname){
                        scol = element.id
                    }
                }
            }

            var subcollectionListSend = [];
            for (let index = 0; index < allcategoryList.length; index++) {
              const element = allcategoryList[index];
              if(element.parentid === parseInt(scol)){
                subcollectionListSend.push({
                  name: element.title,
                  id: String(element.id)
                })
              }
            }
            setSubCategoryList(subcollectionListSend);
        }
    },[allcategoryList,searchParams.get('category')])

    const changeCategory = (e)=>{ 
        var category = "";
        var subcategory = "";
        var brand = "";
        var condition = "";
        var color = "";
        var size = "";
        var orderby = "";
        if(e !== "" && e !== "0"){
            category = "category="+e
        }
        /*if(searchParams.get('subcategory')){
            subcategory = `subcategory=${searchParams.get('subcategory')}`
        }*/
        if(searchParams.get('brand')){
            brand = `&brand=${searchParams.get('brand')}`
        }
        if(searchParams.get('condition')){
            condition = `&condition=${searchParams.get('condition')}`
        }
        if(searchParams.get('color')){
            color = `&color=${searchParams.get('color')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        if(searchParams.get('orderby')){
            orderby = `&orderby=${searchParams.get('orderby')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }
    const changeSubCategory = (e)=>{ 
        var category = "";
        var subcategory = "";
        var brand = "";
        var condition = "";
        var color = "";
        var size = "";
        var orderby = "";
        if(e !== "" && e !== "0"){
            subcategory = "&subcategory="+e
        }
        if(searchParams.get('category')){
            category = `category=${searchParams.get('category')}`
        }
        if(searchParams.get('brand')){
            brand = `&brand=${searchParams.get('brand')}`
        }
        if(searchParams.get('condition')){
            condition = `&condition=${searchParams.get('condition')}`
        }
        if(searchParams.get('color')){
            color = `&color=${searchParams.get('color')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        if(searchParams.get('orderby')){
            orderby = `&orderby=${searchParams.get('orderby')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }

    const changeSort = (e)=>{ 
        var category = "";
        var subcategory = "";
        var brand = "";
        var condition = "";
        var color = "";
        var size = "";
        var orderby = `&orderby=${e}`;
        if(searchParams.get('category')){
            category = `category=${searchParams.get('category')}`
        }
        if(searchParams.get('subcategory')){
            subcategory = `&subcategory=${searchParams.get('subcategory')}`
        }
        if(searchParams.get('brand')){
            brand = `&brand=${searchParams.get('brand')}`
        }
        if(searchParams.get('condition')){
            condition = `&condition=${searchParams.get('condition')}`
        }
        if(searchParams.get('color')){
            color = `&color=${searchParams.get('color')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }

    const changeBrand = (e)=>{ 
        var category = "";
        var subcategory = "";
        var brand = "";
        var condition = "";
        var color = "";
        var size = "";
        var orderby = "";
        if(e !== "" && e !== "0"){
            brand = "&brand="+e
        }
        if(searchParams.get('category')){
            category = `category=${searchParams.get('category')}`
        }
        if(searchParams.get('subcategory')){
            subcategory = `&subcategory=${searchParams.get('subcategory')}`
        }
        if(searchParams.get('condition')){
            condition = `&condition=${searchParams.get('condition')}`
        }
        if(searchParams.get('color')){
            color = `&color=${searchParams.get('color')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        if(searchParams.get('orderby')){
            orderby = `&orderby=${searchParams.get('orderby')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }

    const changeCondition = (e)=>{ 
        var category = "";
        var subcategory = "";
        var brand = "";
        var condition = "";
        var color = "";
        var size = "";
        var orderby = "";
        if(e !== "" && e !== "0"){
            condition = "&condition="+e;
        }
        if(searchParams.get('category')){
            category = `category=${searchParams.get('category')}`
        }
        if(searchParams.get('subcategory')){
            subcategory = `&subcategory=${searchParams.get('subcategory')}`
        }
        if(searchParams.get('brand')){
            brand = `&brand=${searchParams.get('brand')}`
        }
        if(searchParams.get('color')){
            color = `&color=${searchParams.get('color')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        if(searchParams.get('orderby')){
            orderby = `&orderby=${searchParams.get('orderby')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }
    const changeColor = (e)=>{ 
        var category = "";
        var subcategory = "";
        var brand = "";
        var condition = "";
        var color = "";
        var size = "";
        var orderby = "";
        if(e !== "" && e !== "0"){
            color = "&color="+e;
        }
        if(searchParams.get('category')){
            category = `category=${searchParams.get('category')}`
        }
        if(searchParams.get('subcategory')){
            subcategory = `&subcategory=${searchParams.get('subcategory')}`
        }
        if(searchParams.get('brand')){
            brand = `&brand=${searchParams.get('brand')}`
        }
        if(searchParams.get('condition')){
            condition = `&condition=${searchParams.get('condition')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        if(searchParams.get('orderby')){
            orderby = `&orderby=${searchParams.get('orderby')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }

  return (
    <>
    <div className='filter_bar_wrapper'>
        <div className='filter_bar_container'>
            <div className='filter_bar_mainrow'>
                <div className='filter_bar_row'>
                    <Dropdown Lable={"Category"} SetValue={changeCategory} Value={searchParams.get('category') || "0" } Options={categoryList} thisDrop={1} currentDrop={activeDrop} setCurrentDrop={setActiveDrop}/>
                    <Dropdown Lable={"Sub Category"} SetValue={changeSubCategory} Value={searchParams.get('subcategory') || "0" } Options={subcategoryList} thisDrop={2} currentDrop={activeDrop} setCurrentDrop={setActiveDrop}/>
                    <Dropdown Lable={"Brand"} SetValue={changeBrand} Value={searchParams.get('brand') || "0" } Options={brandList} thisDrop={3} currentDrop={activeDrop} setCurrentDrop={setActiveDrop}/>
                    <Dropdown Lable={"Condition"} SetValue={changeCondition} Value={searchParams.get('condition') || "0" } Options={conditionList} thisDrop={4} currentDrop={activeDrop} setCurrentDrop={setActiveDrop}/>
                    <Dropdown Lable={"Color"} SetValue={changeColor} Value={searchParams.get('color') || "0" } Options={colorList} thisDrop={5} currentDrop={activeDrop} setCurrentDrop={setActiveDrop}/>
                </div>
                <div className='filter_bar_row'>
                    <Sort Value={parseInt(searchParams.get('orderby')) || 0 } setValue={changeSort}/>
                </div>
            </div>
        </div>
    </div>
    <div className='filter_selected_bar_row'>
        {searchParams.get('category') &&
            <>
                <div className='filter_selected_bar_item'>
                    <p>{searchParams.get('category')}</p>
                    <button onClick={()=>{
                        changeCategory("");
                    }}><CrossIcon /></button>
                </div>
                {searchParams.get('subcategory') &&
                    <div className='filter_selected_bar_item'>
                        <p>{searchParams.get('subcategory')}</p>
                        <button onClick={()=>{
                            changeSubCategory("");
                        }}><CrossIcon /></button>
                    </div>
                }
            </>
        }
        {searchParams.get('brand') &&
            <div className='filter_selected_bar_item'>
                <p>{searchParams.get('brand')}</p>
                <button onClick={()=>{
                    changeBrand("");
                }}><CrossIcon /></button>
            </div>
        }
        {searchParams.get('condition') &&
            <div className='filter_selected_bar_item'>
                <p>{searchParams.get('condition')}</p>
                <button onClick={()=>{
                    changeCondition("");
                }}><CrossIcon /></button>
            </div>
        }
        {searchParams.get('color') &&
            <div className='filter_selected_bar_item'>
                <p>{searchParams.get('color')}</p>
                <button onClick={()=>{
                    changeColor("");
                }}><CrossIcon /></button>
            </div>
        }
    </div>
    </>
    
  )
}

export default Bar
